import React from 'react';
import { Link } from 'react-router-dom';
import { headwearLandingPages } from '../data/headwearLandingPages.js';
import { headwearContent } from '../data/headwearContent.js';

export default function HeadwearDiscovery({ currentKey }) {
  const relatedKeys = currentKey ? headwearContent[currentKey]?.relatedKeys || [] : null;
  const links = headwearLandingPages.filter((landing) => (
    relatedKeys ? relatedKeys.includes(landing.key) : true
  ));
  if (!links.length) return null;

  return (
    <section className="border-t border-gray-100 bg-white py-10 sm:py-14" dir="rtl" lang="he">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="mb-3 text-2xl font-semibold text-gray-900 sm:text-3xl">
          {currentKey ? 'עוד אפשרויות לכובעים וכיפות' : 'כובעים וכיפות — לפי ההזמנה שלכם'}
        </h2>
        <p className="mb-6 max-w-3xl text-base leading-7 text-gray-600">
          {currentKey
            ? 'משווים בין דגמים וסוגי מיתוג, וממשיכים לפרטי המוצר שמתאים להזמנה.'
            : 'הדפסה או רקמה, כובעים לצוות או כיפות לאירוע — בחרו את הנושא שמתאים לכם כדי לראות דגמים ואפשרויות.'}
        </p>
        <nav aria-label={currentKey ? 'נושאים קשורים בכובעים וכיפות' : 'כובעים וכיפות לפי שימוש ומיתוג'}>
          <ul className="grid list-none gap-3 p-0 sm:grid-cols-2 lg:grid-cols-3">
            {links.map((landing) => (
              <li key={landing.key}>
                <Link
                  to={landing.path}
                  className="block h-full rounded-xl border border-gray-200 px-5 py-4 transition-colors hover:border-blue-400 hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                >
                  <span className="block text-lg font-semibold text-blue-700">{landing.navLabel}</span>
                  <span className="mt-2 block text-sm leading-6 text-gray-600">{headwearContent[landing.key].description}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </section>
  );
}
